module.exports = __webpack_public_path__ + "img/discord-logo.46f97e17.svg";